<template>
  <b-modal id="deleteMediaModal" centered :modal-class="modal_class">
    <div class="d-block mb-4">
      <input id="media_id" name="media_id" type="hidden" v-model="media_id" />
      <input id="client" name="client" type="hidden" v-model="client_name" />
      <p class="confirmMessageModalP my-4" :class="confirm_message_class">
        Are you sure you want to delete this {{ sub_media_type }}?
      </p>
    </div>
    <template class="justify-content-center mt-5" #modal-footer>
      <b-row class="justify-content-center w-100">
        <b-col lg="4" md="6" class="text-center">
          <b-button type="button" :variant="btn_variant_primary" class="w-100 btn-bumblebee" :class="btn_submit_class"
            v-if="!is_loading" @click="clickConfirmDelete">
            Yes
          </b-button>
          <b-button type="button" disabled :variant="btn_variant_primary" class="btn-bumblebee w-100"
            :class="btn_submit_class" v-else>
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col>

        <b-col lg="4" md="6" class="text-center">
          <b-button type="button" :variant="btn_danger_outline_class" class="w-100 btn-bumblebee"
            :class="btn_submit_class" @click="closeModalDelete">
            Cancel
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
<script>
import $ from "jquery";
import axios from "axios";

export default {
  name: "DeleteMedia",
  props: ["client_name", "media_id", "media_type", "sub_media_type",

    "btn_variant_primary", "modal_class", "confirm_message_class",
    "btn_submit_class", "btn_danger_outline_class", "swal_confirm_button_class", "swal_container_class"],
  data() {
    return {
      is_loading: false,
    };
  },

  mounted() { },

  methods: {
    clickConfirmDelete() {
      console.log("in confirm delete media ", this.client_name, this.media_id);
      // return;
      this.is_loading = true;

      axios
        .post(
          "/media/library/delete-media",
          { id: this.media_id },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              client: this.client_name,
              Authorization:
                "Bearer " +
                JSON.parse(window.localStorage.getItem("user")).access_token,
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: response.data.success,
            type: "success",
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
            // timer: 5000,
          }).then((r) => {
            this.$bvModal.hide("deleteMediaModal");
            console.log(this.media_type, this.sub_media_type);
            if (
              this.media_type == "video_library" &&
              this.sub_media_type == "video"
            ) {
              this.$parent.getOpenCategoryVideosList();
            } else if (
              this.media_type == "meditation_library" &&
              this.sub_media_type == "video"
            ) {
              console.log(this.$parent);
              this.$parent.getOpenCategoryVideosList();
            } else if (
              this.media_type == "meditation_library" &&
              this.sub_media_type == "audio"
            ) {
              console.log(this.$parent);
              this.$parent.$parent.getOpenCategoryAudiosList();
              this.$parent.$parent.getMediaCategoryList();
              this.$parent.initComponent();
            } else if (this.media_type == "music_library") {
              console.log(this.$parent);
              this.$parent.$parent.getOpenCategoryMediaList();
              this.$parent.$parent.getMediaCategoryList();
              this.$parent.initComponent();
              this.$parent.initComponent();
            }
          });

          // console.log("test3")
        })
        .catch((error) => {
          // console.log(error.response.data.error);
          // console.log(error.request);
          // console.log(error.message);
          this.is_loading = false;

          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
            // timer: 5000,
          }).then((r) => {
            // console.log(r);
            // console.log(r.value);
          });
          // this.$parent.getUserList()
          // this.loginErrorMessage = error.response.data.error;
          // this.showLoginErrorMessage = true;
        });
    },
    closeModalDelete() {
      this.$bvModal.hide("deleteMediaModal");
    },
  },
};
</script>
  


// WEBPACK FOOTER //
// src/components/media_components/media/DeleteMedia.vue